module.exports = __webpack_public_path__ + "components/country-flag/static/st-a66e38d3051c95e23a7dcb814565d34f.svg";